import React, {useEffect,useRef,useState} from 'react';
export default function FeedVideo({src,poster,className}) {
 const ref=useRef(null);
 const [visible,setVisible]=useState(false);
 const [loaded,setLoaded]=useState(false);
 useEffect(()=>{
  const node=ref.current;
  if(typeof IntersectionObserver==='undefined'){setLoaded(true);setVisible(true);return;}
  const observer=new IntersectionObserver(entries=>{
   const active=entries.some(entry=>entry.isIntersecting);
   setVisible(active);if(active)setLoaded(true);
  },{threshold:0.1});
  if(node)observer.observe(node);
  return ()=>observer.disconnect();
 },[]);
 useEffect(()=>{
  const node=ref.current;if(!node)return;
  if(visible&&loaded){const playback=node.play();playback?.catch(()=>{});}else node.pause();
 },[visible,loaded,src]);
 return <video ref={ref} src={loaded?src:undefined} poster={poster||undefined} preload="none" muted loop playsInline className={className}/>;
}
